import { render, staticRenderFns } from "./NotFoundContracts.vue?vue&type=template&id=31580710&scoped=true"
import script from "./NotFoundContracts.vue?vue&type=script&lang=js"
export * from "./NotFoundContracts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31580710",
  null
  
)

export default component.exports